import { Vue, Component } from 'vue-property-decorator'
import ITagsCloudElement from '~/types/api/TagsCloudElement'
import s from '~/utils/s'

@Component
export default class TagsCloud extends Vue {
  showMore: boolean = false
  get tagsCloud () {
    if (s(this.$store).landingPage.tagsCloud.length > 8 && this.showMore === false) {
      const res = s(this.$store).landingPage.tagsCloud.slice(0, 8)
      res.push({
        title: 'Показать все',
        id: '',
        url: ''
      })
      return res
    } else {
      return s(this.$store).landingPage.tagsCloud
    }
  }

  render () {
    return (
      <div>
        {this.tagsCloud?.map((e: ITagsCloudElement) => {
          const isShowMore = e.title === 'Показать все'

          return (
            <a
              class="tag-cloud__tag"
              href={isShowMore ? '#' : e.url}
              onClick={(event: MouseEvent) => {
                event.preventDefault()
                if (isShowMore) {
                  this.showMore = true
                } else {
                  this.$router.push(e.url)
                }
              }}
            >
              {e.title}
            </a>
          )
        })}
      </div>
    )
  }
}
